import { useAuth0 } from '@auth0/auth0-vue'
import { useLocalStorage } from '@vueuse/core'

import { FILTERS_KEYS } from '@/constants'

export function useSavedFilters<T>(defaultFilters: T, filterName: string) {
  const { user } = useAuth0()

  const getStorageKey = (filterName: string) => {
    const userId = user.value?.sub || 'guest'
    return `${filterName}_${userId}`
  }

  const filters = useLocalStorage<T>(getStorageKey(filterName), defaultFilters)

  return {
    filters,
  }
}

export function clearFilters(userId: string = 'guest') {
  const storageKeys = FILTERS_KEYS.map(name => `${name}_${userId}`)
  storageKeys.forEach(key => {
    localStorage.removeItem(key)
  })

  localStorage.clear()
}
